/* vr-cc-quick-add.js — touch-only size picker for vr-cc product cards.
   The cards' size bar is :hover-revealed, which never fires on touch, so a
   "+" opens a bottom sheet instead. Client direction 2026-08-25: the sheet
   mirrors the desktop bar — every size links to the PDP, nothing is added to
   the bag here. Progressive enhancement: the button stays hidden until this
   script marks <html> ready. Vanilla ES6, no jQuery (project rule). */
(function () {
  'use strict';

  /* Both card sections load this file; guard against executing twice. */
  if (window.__vrCcQuickAdd) return;
  window.__vrCcQuickAdd = true;

  var SLIDE_MS = 280;    /* must match the sheet transition in the CSS */
  var FOCUSABLE = 'button:not([disabled]), a[href]';

  var sheet = null;      /* the one sheet element, built on first open */
  var els = null;        /* its inner parts, cached */
  var opener = null;     /* the "+" that opened it, to restore focus to */
  var hideTimer = null;  /* sets hidden once the slide-down has played */
  var watcher = null;    /* keeps app markup out of the sheet while open */
  var savedScroll = 0;

  /* Scroll lock: position:fixed, because iOS Safari scrolls behind an
     overflow-hidden <html>. Offset restored on close. */
  function lockScroll() {
    /* Locking twice would read 0 off the already-fixed body and close would
       jump the shopper to the top of the page. */
    if (document.documentElement.classList.contains('vr-cc-noscroll')) return;
    savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = -savedScroll + 'px';
    document.documentElement.classList.add('vr-cc-noscroll');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('vr-cc-noscroll');
    document.body.style.top = '';
    window.scrollTo(0, savedScroll);
  }

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'vr-cc-qa';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="vr-cc-qa__backdrop" data-qa-close></div>' +
      '<div class="vr-cc-qa__sheet" role="dialog" aria-modal="true" aria-labelledby="vr-cc-qa-title">' +
        '<button type="button" class="vr-cc-qa__close" data-qa-close aria-label="Close size picker"></button>' +
        '<div class="vr-cc-qa__head">' +
          '<span class="vr-cc-qa__names">' +
            '<span class="vr-cc-qa__title" id="vr-cc-qa-title"></span>' +
            '<span class="vr-cc-qa__colorway" hidden></span>' +
          '</span>' +
          '<span class="vr-cc-qa__price"></span>' +
        '</div>' +
        '<div class="vr-cc-qa__sizes"></div>' +
      '</div>';
    document.body.appendChild(sheet);

    els = {
      panel: sheet.querySelector('.vr-cc-qa__sheet'),
      title: sheet.querySelector('.vr-cc-qa__title'),
      colorway: sheet.querySelector('.vr-cc-qa__colorway'),
      price: sheet.querySelector('.vr-cc-qa__price'),
      sizes: sheet.querySelector('.vr-cc-qa__sizes')
    };

    /* Only closing is scripted: size pills are <a href> and navigate. */
    sheet.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-qa-close]')) close();
    });

    /* Keep Tab inside the sheet while it is open. */
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = els.panel.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* The restock app injects its "Notify me" inside the card nodes this sheet
     copies from, and can inject into the open sheet too; CSS only hides it,
     and hidden text still reads via textContent. Strip it here so the sheet
     is clean even if vr-cc-app-guard.js never loads. */
  var APP_UI = '.nm-portal, [class*="notify"], [class*="restock-alert"]';

  /* Node text with any injected app markup removed first. */
  function ownText(node) {
    if (!node) return '';
    var copy = node.cloneNode(true);
    var junk = copy.querySelectorAll(APP_UI);
    for (var i = 0; i < junk.length; i++) junk[i].remove();
    return (copy.textContent || '').trim();
  }

  function scrub(root) {
    if (!root) return;
    var junk = root.querySelectorAll(APP_UI);
    for (var i = 0; i < junk.length; i++) {
      var n = junk[i];
      (n.closest('.nm-portal') || n).remove();
    }
  }

  /* The size nodes rendered for the desktop hover bar are the source of
     truth: they already resolve the first in-stock variant per size and carry
     PDP links. */
  function readSizes(card) {
    var nodes = card.querySelectorAll('.vr-cc-card__size');
    /* Whole-card link backstops a size node with no href of its own. */
    var main = card.querySelector('.vr-cc-card__link');
    var fallback = main ? main.getAttribute('href') : '';
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      out.push({
        label: ownText(n),
        href: n.getAttribute('href') || fallback,
        /* Sold out changes how the pill looks, never whether it can be tapped. */
        soldOut: n.classList.contains('vr-cc-card__size--out')
      });
    }
    return out;
  }

  function text(card, selector) {
    return ownText(card.querySelector(selector));
  }

  function renderSizes(list) {
    els.sizes.innerHTML = '';
    list.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'vr-cc-qa__size' + (s.soldOut ? ' vr-cc-qa__size--out' : '');
      if (s.href) a.href = s.href;
      a.textContent = s.label;
      /* The strike-through is the only visual sold-out cue; spell it out. */
      if (s.soldOut) a.setAttribute('aria-label', s.label + ' — sold out, open product page');
      els.sizes.appendChild(a);
    });
  }

  function open(button) {
    var card = button.closest('.vr-cc-card');
    if (!card) return;
    if (!sheet) build();

    window.clearTimeout(hideTimer);   /* re-opened mid slide-down */
    opener = button;

    els.title.textContent = text(card, '.vr-cc-card__title');
    els.price.textContent = text(card, '.vr-cc-card__price');
    /* Hidden rather than empty so the head reserves no blank line. */
    var colorway = text(card, '.vr-cc-card__colorway');
    els.colorway.textContent = colorway;
    els.colorway.hidden = !colorway;
    renderSizes(readSizes(card));

    /* The app re-scans on DOM changes, and opening the sheet is one. */
    scrub(sheet);
    if (!watcher) {
      watcher = new MutationObserver(function () { scrub(sheet); });
      watcher.observe(sheet, { childList: true, subtree: true });
    }

    sheet.hidden = false;
    lockScroll();
    button.setAttribute('aria-expanded', 'true');

    /* Next frame, so the slide-up has a from-state; focusing the still
       off-screen panel would make the browser scroll it into view. */
    window.requestAnimationFrame(function () {
      sheet.classList.add('vr-cc-qa--open');
      /* Land focus on an in-stock size when there is one. */
      var first = els.panel.querySelector('.vr-cc-qa__size:not(.vr-cc-qa__size--out)') ||
                  els.panel.querySelector('.vr-cc-qa__size') ||
                  els.panel.querySelector('.vr-cc-qa__close');
      if (first) first.focus();
    });
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('vr-cc-qa--open');
    /* A timer rather than transitionend, which never fires under
       prefers-reduced-motion. */
    unlockScroll();
    hideTimer = window.setTimeout(function () { sheet.hidden = true; }, SLIDE_MS);
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (document.contains(opener)) opener.focus();
      opener = null;
    }
  }

  /* Delegated from document, so editor-added cards need no rebinding. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-vr-qa]');
    if (!toggle) return;
    e.preventDefault();
    if (sheet && !sheet.hidden && opener === toggle) close();
    else open(toggle);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden) close();
  });

  /* A section reload detaches the card the sheet was opened from. */
  document.addEventListener('shopify:section:load', close);

  document.documentElement.classList.add('vr-cc-qa-ready');
}());
